__turbopack_context__.v({
  "blackTable": "gm3FKW_blackTable",
  "blueTable": "gm3FKW_blueTable",
  "defaultTable": "gm3FKW_defaultTable",
  "initial": "gm3FKW_initial",
  "plainTable": "gm3FKW_plainTable",
  "richText": "gm3FKW_richText",
  "tableOfContent": "gm3FKW_tableOfContent",
  "tableWithoutHeader": "gm3FKW_tableWithoutHeader",
});
